
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game",
      function () {
        return require("private-next-pages/game.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game"])
      });
    }
  